import { useProvider, useVariant } from "hooks/tivoApps";

export const useVariantFormData = (
  id?: string,
  variantId?: string,
  versionId?: string
) => {
  const providerQuery = useProvider(id);
  const variantQuery = useVariant(id, variantId, { include: "versions" });

  const selectedVersion =
    variantQuery.data?.results?.versions?.find((v) => v.id === versionId) ||
    variantQuery.data?.results?.versions?.[0]; // Backend returns versions sorted by creation date

  return {
    providerData: providerQuery.data,
    variantData: variantQuery.data,
    isLoading: providerQuery.isLoading || variantQuery.isLoading,
    error: providerQuery.error || variantQuery.error,
    selectedVersion,
  };
};
